export const useSite = () => 'rareTradesCentre' as const;
export const useIsRTC = () => true as const;
export const withSite = <T extends Record<string, unknown>>(variables?: T | null) =>
  ({ ...variables }) as T & { site: string };
